<template>
    <div class="container-actions-filter">
        <section v-if="!$mx_userIsBroker" class="section-filter-data">
            <span class="text-filter-data">Filtrar dados: </span>
            <div 
                @click="() => setTeams('team')" 
                v-if="!$mx_userIsManager">
                <ui-select-v2
                    placeholder="Equipes"
                    design="mgb-0 mw-200"
                    multiple
                    v-model="filterData.team"
                    itemLabel="name"
                    returnValue="object"
                    ajax-search
                    search-event="teams"
                    callWithEmptySearch
                    :loading="isTeamsLoading"
                    :data="dynamicTeam.team.data"
                    cancel-event="request-teams"
                    />
            </div>
            <div @click="() => setTeams('manager')" v-if="!$mx_userIsManager">
                <ui-select-v2
                    placeholder="Gerentes"
                    design="mgb-0 mw-200"
                    multiple
                    v-model="filterData.manager"
                    itemLabel="name"
                    returnValue="object"
                    ajax-search
                    search-event="managers"
                    :loading="isManagerLoading"
                    :data="dynamicTeam.manager.data"
                    groupBy="team"
                    :disabled="dynamicFilters.teamFilter.team.length === 0 && !$mx_userIsManager"
                    cancel-event="request-managers"
                    />
            </div>
            <div @click="() => setTeams('broker')">
                <ui-select-v2
                    placeholder="Corretor"
                    design="mgb-0 mw-200"
                    multiple
                    v-model="filterData.broker"
                    itemLabel="name"
                    returnValue="object"
                    groupBy="manager"
                    ajax-search
                    search-event="brokers"
                    :data="dynamicTeam.broker.data"
                    :loading="isBrokerLoading"
                    cancel-event="request-brokers"
                    :disabled="dynamicFilters.teamFilter.manager.length === 0 && !$mx_userIsManager"
                    />
            </div>
        </section>

        <section class="section-filter-date">
            <div class="filter-steps">
                <span
                    class="day"
                    :class="{'filter-step-day': dynamicFilters.timePeriod == 'day'}"
                    @click="handleSelectionPeriod('day')"
                >
                    Diário
                </span>

                <span
                    class="week"
                    :class="{'filter-step-week': dynamicFilters.timePeriod == 'week'}"
                    @click="handleSelectionPeriod('week')"
                >
                    Semanal
                </span>

                <span
                    class="month"
                    :class="{'filter-step-month': dynamicFilters.timePeriod == 'month'}"
                    @click="handleSelectionPeriod('month')"
                >
                    Mensal
                </span>
            </div>

            <div class="filter-calendar">
                <ui-calendar-range
                    :onClickApply="handleSelectDateRange"
                    :isButtonActive="dynamicFilters.dateRange.finalDate && !dynamicFilters.timePeriod"
                />
            </div>

            <div class="apply-clean-filters">
                <ui-button
                    design="primary md"
                    :disabled="loading"
                    @click="applyFilters"
                >
                    Aplicar Filtros
                </ui-button>

                <span
                    v-if="hasAppliedFilters"
                    class="clear-filters"
                    @click="clearFilters"
                >
                    Limpar Filtros
                </span>
            </div>
        </section>
    </div>
</template>

<script>
    import { uiButton } from '@/components/ui/buttons'
    import { uiCalendarRange, uiSelectV2 } from '@/components/ui/form'
    import { permissionsMixin, utilMixin } from '@/mixins'
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
    const moment = require('moment')
	require('moment/locale/pt-br')

    export default {
        name: 'actions-filter',

        components: {
            uiSelectV2,
            uiCalendarRange,
            uiButton
        },

		mixins: [ permissionsMixin, utilMixin],

        data() {
            return {
                filterStep: '',
                filterData: {
                    team: [],
                    manager: [],
                    broker: []
                },
                isTeamsLoading: false,
                isManagerLoading: false,
                isBrokerLoading: false
            }
        },

        created() {
            this.filterData.team = this.dynamicFilters.teamFilter.team || [];
            this.filterData.manager = this.dynamicFilters.teamFilter.manager || [];
            this.filterData.broker = this.dynamicFilters.teamFilter.broker || [];
            // Paginação e pesquisa dos dropdowns times, gerentes e Corretores
			this.$root.$on('select-v2-ajax-search-teams', ({ search, nextPage }) => {
				if(this.isTeamsLoading) return 
                if(!nextPage){
                    return this.callTeam({ page: 1, search})
                }

                if(this.dynamicTeam.team.currentPage < this.dynamicTeam.team.lastPage){
                    this.callTeam({ page: this.dynamicTeam.team.currentPage + 1, search, nextPage })
                }
			})

            this.$root.$on('select-v2-ajax-search-managers', ({ search, nextPage }) => {
                if(this.isManagerLoading) return

                if(!nextPage){
                    return this.callManager({ page: 1, search})
                }

                if(this.dynamicTeam.manager.currentPage < this.dynamicTeam.manager.lastPage){
                    this.callManager({ page: this.dynamicTeam.manager.currentPage + 1, search, nextPage })
                }
			})

            this.$root.$on('select-v2-ajax-search-brokers', ({ search, nextPage }) => {

                if(this.isBrokerLoading) return 
                if(!nextPage){
                    return this.callBroker({ page: 1, search})
                }

                if(this.dynamicTeam.broker.currentPage < this.dynamicTeam.broker.lastPage){
                    this.callBroker({ page: this.dynamicTeam.broker.currentPage + 1, search, nextPage })
                }
			})
		},

        beforeDestroy() {
			this.$root.$off('select-v2-ajax-search-teams')
			this.$root.$off('select-v2-ajax-search-managers')
			this.$root.$off('select-v2-ajax-search-brokers')
		},

        computed: {
            ...mapState('dashboardFilter', ['dynamicTeam', 'dynamicFilters', 'appliedFilters', 'loading']),
            ...mapGetters('auth', { user: 'getUser' }),
            // verifica se os filtros foram aplicados
            hasAppliedFilters() {
                const filters = this.appliedFilters;
                let hasFilters = false

                if (this.$mx_hasValue(filters.timePeriod)) {
                    hasFilters =  true;
                }

                if (this.$mx_hasValue(filters.dateRange.initialDate) ||
                    this.$mx_hasValue(filters.dateRange.finalDate)) {
                    hasFilters =  true;
                }

                if ((filters.comparativeDate.initialDate && filters.comparativeDate.initialDate !== '') ||
                    (filters.comparativeDate.finalDate && filters.comparativeDate.finalDate !== '')) {
                return true;
                }

                if (this.$mx_hasValue(filters.teamFilter.team) ||
                    this.$mx_hasValue(filters.teamFilter.manager) ||
                    this.$mx_hasValue(filters.teamFilter.broker)) {
                    hasFilters =  true;
                }

                return hasFilters;
            },

        },

        methods: {
            ...mapMutations('dashboardFilter', ["UPDATE_TEAM_FILTER", "UPDATE_PERIOD_TYPE", "UPDATE_DATE_RANGE"]),
            ...mapActions('dashboardFilter', ['fetchTeams', 'fetchManagers', 'fetchBrokers', 'updateTeamFilter']),

            async callTeam({ page, search, nextPage }){
                this.isTeamsLoading = true
                await this.fetchTeams({page, search, nextPage})
                this.isTeamsLoading = false
            },

            async callManager({ page, search, nextPage }){
                this.isManagerLoading = true
                await this.fetchManagers({page, search, nextPage})
                this.isManagerLoading = false
            },

            async callBroker({ page, search, nextPage }){
                this.isBrokerLoading = true
                await this.fetchBrokers({page, search, nextPage})
                this.isBrokerLoading = false
            },
            // Chamada busca os times ao clicar pela primeira vez
            async setTeams(type) {
                if(type === 'team' && (this.dynamicTeam.team.length === 0 || this.dynamicTeam.team?.data.length === 0)){
                    return this.callTeam({ page: 1 })
                }

                if(type === 'manager' && (this.dynamicFilters.teamFilter.team.length > 0 || this.$mx_userIsManager) &&  this.dynamicTeam.manager.length === 0){
                    this.isManagerLoading = true
                    await this.fetchManagers({ page: 1 })
                    this.isManagerLoading = false
                }
                if(type === 'broker' && (this.dynamicFilters.teamFilter.manager.length > 0 || this.$mx_userIsManager) && this.dynamicTeam.broker.length === 0){
                    this.isBrokerLoading = true
                    await this.fetchBrokers({ page: 1 })
                    this.isBrokerLoading = false
                }
            },
             // Método para Equipes
             async handleSelectionTeam(type) {
                this.isTeamsLoading = true
                const selectedValues = this.filterData[type]?.length 
                    ? this.filterData[type].map(v => ({ id: v.id, name: v.name }))
                    : [];

                await this.updateTeamFilter({ filterType: type, selectedValues });

                this.isTeamsLoading = false
            },

             // Método para período de tempo
             handleSelectionPeriod(period) {
                this.UPDATE_PERIOD_TYPE(period)
            },

            handleSelectDateRange(e) {
                this.UPDATE_DATE_RANGE({
                    initialDate: moment(e.initialDate).format('YYYY-MM-DD'),
                    finalDate: moment(e.finalDate).format('YYYY-MM-DD')
                });
            },

            applyFilters() {
                this.$store.dispatch('dashboardFilter/applyFilters')
            },

            clearFilters() {
				this.$root.$emit('select2-cancel-event-request-teams')
				this.$root.$emit('select2-cancel-event-request-managers')
				this.$root.$emit('select2-cancel-event-request-brokers')
                this.$store.dispatch('dashboardFilter/resetFilters')
                this.callTeam({ page: 1 })

                this.filterData.team = [];
                this.filterData.manager = [];
                this.filterData.broker = [];
            },
             // Função para reconciliar os itens selecionados com os dados disponíveis
             reconcileSelectedItems(type, data) {
                const selectedItems = Array.isArray(this.filterData[type]) ? this.filterData[type] : [];
                const selectedIds = selectedItems.map(item => item.id);

                const currentData = Array.isArray(data) ? data : [];

                const missingSelectedItems = selectedItems.filter(
                    selectedItem => !currentData.some(item => item.id === selectedItem.id)
                );

                const combinedData = [...currentData, ...missingSelectedItems].filter(
                    (item, index, self) => index === self.findIndex(t => t.id === item.id)
                );

                const reconciledSelectedItems = combinedData.filter(item => selectedIds.includes(item.id));

                // Atualiza filterData sem remover itens selecionados
                this.$set(this.filterData, type, reconciledSelectedItems);
            },
        },
        watch: {
            'filterData.team': {
                handler(newValue, oldValue) {
                    const newIds = (newValue || []).map(item => item.id).sort().join(',');
                    const oldIds = (oldValue || []).map(item => item.id).sort().join(',');
                    if (newIds !== oldIds) {
                        this.handleSelectionTeam('team');
                    }
                },
                deep: false
            },
            'filterData.manager': {
                handler() {
                    this.handleSelectionTeam('manager');
                },
                deep: true
            },
            'filterData.broker': {
                handler() {
                    this.handleSelectionTeam('broker');
                },
                deep: true
            },
            'dynamicTeam.team.data': {
                handler(newData) {
                    this.reconcileSelectedItems('team', newData);
                },
                immediate: true,
            },
            'dynamicTeam.manager.data': {
                handler(newData) {
                    if (Array.isArray(newData)) {
                        this.reconcileSelectedItems('manager', newData);
                    } else {
                        this.reconcileSelectedItems('manager', []);
                    }
                },
                immediate: true,
            },
            'dynamicTeam.broker.data': {
                handler(newData) {
                    if (Array.isArray(newData)) {
                        this.reconcileSelectedItems('broker', newData);
                    } else {
                        this.reconcileSelectedItems('broker', []);
                    }
                },
                immediate: true,
            },
            'dynamicFilters.teamFilter.team': {
                handler(newValue, oldValue) {
                    const newIds = (newValue || []).map(item => item.id).sort().join(',');
                    const oldIds = (oldValue || []).map(item => item.id).sort().join(',');
                    if (newIds !== oldIds) {
                        // Reseta gerentes e corretores sempre que as equipes mudarem
                        this.filterData.manager = [];
                        this.filterData.broker = [];
                    }
                },
                deep: false,
                immediate: true
            },

            'dynamicFilters.teamFilter.manager': {
                handler(newValue, oldValue) {
                    const newIds = (newValue || []).map(item => item.id).sort().join(',');
                    const oldIds = (oldValue || []).map(item => item.id).sort().join(',');
                    if (newIds !== oldIds) {
                        // Reseta corretores sempre que os gerentes mudarem
                        this.filterData.broker = [];
                    }
                },
                deep: false,
                immediate: true
            },
        }

    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>